import * as React from "react";
import { useEffect, useState } from "react";
import { useNomaContext } from "../../Contexts/MapContext";
import { useRegistrationContext } from "../../Contexts/RegistrationContext";
import { IObjectSection, ISummaryParams } from "./SummarySection";

export const ObjectSection = ({ data }: { data?: ISummaryParams }): JSX.Element => {
    const [dataJson, setDataJson] = useState<IObjectSection>();

    const { getObjectSectionJson } = useRegistrationContext();
    const { snapshotBig, snapshotSmall } = useNomaContext();

    useEffect(() => {
        setDataJson(data ? data : getObjectSectionJson());
    }, []);

    return dataJson ? (
        <div className="object-section">
            <div className="object-section-header">
                <div>
                    {dataJson.header.headerRows.map((row) => (
                        <div key={row.alias + row.value}>
                            <span>{row.alias}</span>
                            <span>{row.value}</span>
                        </div>
                    ))}
                </div>
                <div className="snapshots-block">
                    <img className="snapshot" src={snapshotBig}></img>
                    <img className="snapshot" src={snapshotSmall}></img>
                </div>
            </div>
            {dataJson.objectInfoRows.map((row) =>
                row ? (
                    <div className="row" key={row.alias + row.value}>
                        {row.alias ? <span>{row.alias}</span> : null}
                        {row.value ? <span>{row.value}</span> : null}
                    </div>
                ) : null
            )}
        </div>
    ) : null;
};
